export const onBoardingStatus = {
  REGISTERED: 'registered',
  STORE_CONNECTED: 'store_connected',
  QUESTIONNAIRE_COMPLETED: 'questionnaire_completed',
};

const { hostname } = window.location;
// eslint-disable-next-line no-nested-ternary
export const env = (hostname.indexOf('dev') > -1 || hostname.includes('test')) ? 'dev' : (hostname.indexOf('localhost') > -1 ? 'local' : 'prod');

export const PREFILLED_SHOP_DOMAIN_KEY = 'PREFILLED_SHOP_DOMAIN_ON_CONNECTION_PAGE';

export * from './api';
export * from './policy';
export * from './storage';
export * from './img';
export * from './specialMerchantID';

export default {
  onBoardingStatus,
  env,
};

/** 邮箱地址 */
export const EmailAddress = {
  Seel: 'merchant@seel.com',
  Support: 'support@seel.com',
};

// 所有产品的名称map
export const PRODUCT_NAME = {
  RETURN_ASSURANCE: 'Return Assurance',
  BUYER_PROTECTION: 'Buyer Protection',
  SHIPPING_PROTECTION: 'Shipping Protection',
  GREEN_SHIPPING_PROTECTION: 'Green Shipping Protection',
  BUYBACK_GUARANTEE: 'Buyback Guarantee',
  EXTENDED_WARRANTY: 'Extended Warranty',
  INSTANT_REFUND: 'Instant Refund',
  GUARANTEED_DELIVERY_DATE: 'Guaranteed Delivery Date',
  ESTIMATED_DELIVERY_DATE: 'Estimated Delivery Date',
  ASSURED_SALE: 'Assured Sale',
  DELIVERY_GUARANTEE: 'Delivery Guarantee',
  WORRY_FREE_PURCHASE: 'Worry-Free Purchase',
  RETURNABLE: 'Make it Returnable',
};

export const FULFILLMENT_REQUIREMENTS = [
  {
    value: 'fulfill_first_good',
    label: 'Fulfill when first item(s) are fulfilled',
    recommended: 'Recommended',
  },
  {
    value: 'fulfill_all_good',
    label: 'Fulfill when all items are fulfilled',
  },
  {
    value: 'fulfill_instant',
    label: 'Fulfill upon purchase',
  },
  {
    value: 'no_fulfill',
    label: 'Do not fulfill automatically',
  },
];

export const getFulfillmentText = (bpName) => [`Fulfill when first item(s) are fulfilled: ${bpName} is fulfilled when any item(s) in this order are fulfilled.`, `Fulfill when all items are fulfilled: ${bpName} is fulfilled when all other items in the order are fulfilled.`, `Fulfill upon purchase: ${bpName} is fulfilled as soon as the order is placed.`, `Do not fulfill automatically: ${bpName} is fulfilled when manual fulfillment marking.`];

export const STYTCH_PUBLIC_TOKEN = env === 'prod' ? 'public-token-live-e9f1ce8c-eebe-4f0a-a63d-bfced5dde086' : 'public-token-test-898dd57c-c285-452f-a205-b77793f9e1da';
export const STYTCH_PROJECT_ID = 'project-live-e0966f46-3ab0-40ba-95a8-3d7e0373b838';
export const STYTCH_SECRET = 'secret-live-77W7lgj-W58Lpd6ZxZPOXmQu7TSIgE-6aww=';

export const NeedShowDeliveryGuarantee = ['shoppremiumoutlets-gsp', '1018', 'ctbids-gsp', '1035', 'ldj-gsp', '1032'];
export const NeedShowWorryFreePurchase = ['shopify_bp', 'poizon-gsp', '1024', 'seel_shopify-wfp', 'bazo_shopify-wfp'];

export const NeedShowMakeItReturnable = ['ctbids-ra', '1030', 'ldj-ra', '1031'];

export const SPODomain = ['shoppremiumoutlets.myshopify.com', 'sspotest.myshopify.com'];

// policy detail页面根据返回的policyType来表示WFP
export const PRODUCT_NAME_FOR_WFP = ['1041', '1042', '1043', '1045'];

// 根据insurance_id判断是否显示为bp
export const BP_INSURANCE_ID_MAP = ['4', '8', '12', '17', '21', '31', '1000', '1035', '1032', '1042', '1043', '1045'];

export const ONE_WIDGET_MAP = ['1042', '1043', '1045'];
